import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {
  RecoilRoot
} from 'recoil';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'firebaseui/dist/firebaseui.css';
import 'firebaseui/dist/firebaseui.js';
import "react-image-gallery/styles/css/image-gallery.css";

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
